










import { Component, Vue } from 'vue-property-decorator';
import Topbar from '@/components/Topbar.vue';
import Auth from "@/components/Auth.vue";
// import '../firebaseConfig';

@Component({
components: {
    Topbar,
    Auth
  }
})
export default class Login extends Vue {

}
